import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { HeaderStewardship } from './header/Header';

export const StewardshipWrapper: FC = () => {
  return (
    <div className="w-full h-screen flex flex-col">
      <HeaderStewardship />

      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};
